import {ISimpleFilterParams} from 'ag-grid-community';

export function getBasicFilterParams(): ISimpleFilterParams {
  return {
    buttons: ['reset'],
    maxNumConditions: 1,
  };
}
